import api from '../services/Api';
import {pendingRequest, finishedRequest, updateRequestStatus} from '../actions/SubscribeActions';

class SubscribeRepository {

    /**
     * Subscribe to newsletter
     *
     * @param {string} email
     * @param {string} country
     * @param {string} consents
     * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
     */

    subscribe = (email, country, consents) => (dispatch) => {
        dispatch(pendingRequest());

        return api.post('/subscribe', {email, country, consents})
            .then(result => {
                dispatch(updateRequestStatus(result.data.success));
            })
            .catch(e => {
                console.error(e);
                dispatch(updateRequestStatus(false));
            })
            .then(() => {
                dispatch(finishedRequest())
            })
    }
}

export default new SubscribeRepository();



// WEBPACK FOOTER //
// ./repositories/SubscribeRepository.js